import React, { forwardRef } from "react";
import "../styles/SearchBar.css";

// Use forwardRef to forward the ref (the information it recieves) to the input element
const SearchBar = forwardRef(({ placeholder, value, onChange }, ref) => {
  return (
    <div className="search-bar-container">
      <input 
        ref={ref} // Attach the ref to the input element
        className="search-bar-input" 
        name="myInput" 
        placeholder={placeholder || "Search Services"} 
        value={value}
        onChange={onChange}
      />
      <button type="submit" className="search-bar-button">Search</button>
    </div>
  );
});

export default SearchBar;